import React from 'react'
import { MenuIcon } from '../ui/Icons'

interface HamburgerButtonProps {
  onClick: () => void
  isOpen: boolean
}

/**
 * Hamburger menu button for mobile navigation
 * Meets WCAG touch target requirements (48x48px)
 */
export const HamburgerButton: React.FC<HamburgerButtonProps> = ({
  onClick,
  isOpen
}) => {
  return (
    <button
      onClick={onClick}
      aria-label={isOpen ? 'Close navigation menu' : 'Open navigation menu'}
      aria-expanded={isOpen}
      className="
        fixed top-4 left-4 z-[60]
        w-12 h-12
        flex items-center justify-center
        bg-white/80 backdrop-blur-xl
        border border-gray-200/50
        rounded-xl
        shadow-lg
        text-gray-900
        hover:bg-white/90 hover:shadow-xl
        active:scale-95
        transition-all duration-150
        focus:outline-none focus:ring-2 focus:ring-admin-orange-500 focus:ring-offset-2 focus:ring-offset-gray-50
        md:hidden
      "
      data-testid="hamburger-button"
    >
      <MenuIcon size="md" />
    </button>
  )
}
